import { ContainerProps } from "./helper";
import './Container.scss';

const Container = ({ children }: ContainerProps): JSX.Element =>
(
    <div className="content">
        {children}
    </div>
)

export default Container;